import { Component, Input, Output, EventEmitter, OnChanges, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { DynamicControl } from '@shared/models/dynamic-form-control.model';
import { DynamicFormService } from './dynamic-form.service';
import { TranslateService } from '@ngx-translate/core';
import { pairwise, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  providers: [DynamicFormService],
  styleUrls: ['./dynamic-form.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DynamicFormComponent implements OnChanges {

  @Input() controls: DynamicControl<any>[] = [];
  @Input() caseItemStatus: string;
  @Input() isMainCaseItem: boolean;
  @Output() formSubmit: EventEmitter<any> = new EventEmitter();
  @Output() backEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() formModification: EventEmitter<any> = new EventEmitter();
  @Output() addRow: EventEmitter<any> = new EventEmitter();
  @Output() removeRow: EventEmitter<any> = new EventEmitter();
  @Output() rowOrderChanged: EventEmitter<any> = new EventEmitter();

  form: UntypedFormGroup;
  payLoad = '';
  validValueSet: boolean = false;
  private controlKeySelected: string = null;

  constructor(private qcs: DynamicFormService, private translate: TranslateService) { }

  onSubmit() {
    this.payLoad = JSON.stringify(this.form.value);
    this.formSubmit.emit(this.payLoad);
  }

  onBackClick() {
    this.backEvent.emit('backButton clicked');
  }

  ngOnChanges() {
    this.form = this.qcs.toFormGroup(this.controls, this.caseItemStatus);
    this.form.updateValueAndValidity();
    this.form.valueChanges.pipe(startWith(this.form.value), pairwise()).subscribe(([prev, next]) => {
      this.formModification.emit(this.getChangedValue(prev, next))
    });
    this.validValueSet = true;
  }

  onValueAutoComplete(event: any){
    this.form.controls[this.controlKeySelected].setValue(event);
  }

  getChangedValue(prev: any, next: any){
    for(let key in next){
      //if data is an array it is a table
      if(Array.isArray(next[key])){
        for(let i = 0; i < next[key].length; i++){
          for(let cell in next[key][i]){
            if(next[key][i][cell] !== prev[key][i][cell]){
              return {controlName: key, formValue: next[key][i][cell], childRow: i, childKey: cell};
            }
          }
        }
      }
      else{
        if(next[key] !== prev[key]){
          return {controlName: key, formValue: next[key]};
        }
      }
    }
  }

  receiveSelectedControl(event: any) {
    this.controlKeySelected = event.controlName;
  }

  rowAdd(event: any){
    this.addRow.emit(event)
  }

  rowRemove(event: any){
    this.removeRow.emit(event);
  }

  changeRowOrder(event: any){
    this.rowOrderChanged.emit(event);
  }
}
